/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityNotificationsResult
 */
export interface MonitEntityNotificationsResult {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    notification_type?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    contact_type?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    recipient?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    status_external?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNotificationsResult
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityNotificationsResult
     */
    sent_at?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityNotificationsResult
     */
    created?: number;
}

/**
 * Check if a given object implements the MonitEntityNotificationsResult interface.
 */
export function instanceOfMonitEntityNotificationsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityNotificationsResultFromJSON(json: any): MonitEntityNotificationsResult {
    return MonitEntityNotificationsResultFromJSONTyped(json, false);
}

export function MonitEntityNotificationsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityNotificationsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'notification_type': !exists(json, 'notification_type') ? undefined : json['notification_type'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
        'recipient': !exists(json, 'recipient') ? undefined : json['recipient'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'status_external': !exists(json, 'status_external') ? undefined : json['status_external'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'sent_at': !exists(json, 'sent_at') ? undefined : json['sent_at'],
        'created': !exists(json, 'created') ? undefined : json['created'],
    };
}

export function MonitEntityNotificationsResultToJSON(value?: MonitEntityNotificationsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'notification_type': value.notification_type,
        'contact_type': value.contact_type,
        'recipient': value.recipient,
        'status': value.status,
        'status_external': value.status_external,
        'reason': value.reason,
        'sent_at': value.sent_at,
        'created': value.created,
    };
}

